export default {
  '创建时间': 'Creation At',
  '操作': 'Operation',
  '更多': 'More',
  '查询': 'Search',
  '重置': 'Reset',
  '新增': 'Add',
  '编辑': 'Edit',
  '详情': 'Details',
  '删除': 'Delete',
  '批量删除': 'Bulk Delete',
  '类型': 'Type',
  '类型名称': 'Type Name',
  '类型图片': 'Type Image',
  '温度': 'Temperature',
  '设备名称': 'Device Name',
  '设备编号': 'Device No.',
  '是否报警': 'Alarm Status',
  '用户登录号': 'User Login ID',
  '用户昵称': 'User Nickname',
  '总报警次数': 'Total Alarm Count',
  '今日报警次数': 'Today’s Alarm Count',
  '采集值': 'Collection Value',
  '单位': 'Unit',
  '用户': 'User',
  '设备类型': 'Device Type',
  '报警阀值': 'Alarm threshold',
  '报警阀值上偏差': 'Deviation above alarm threshold',
  '报警阀值下偏差': 'Deviation below alarm threshold',
  '设备地址': 'Device Address',
  '看板': 'bulletin board',
  '历史数据': 'Historical Data',
  '报警数据': 'Alarm Data',
  '信息概括': 'Information Summary',
  '历史统计图': 'Historical Statistical Chart',
  '报警统计图': 'Alarm Statistics Chart',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '日期范围': 'Date Range',
  '采集类型': 'Collection Type',
  '报警类型': 'Alarm Type',
  '低报': 'low alarm',
  '高报': 'High alarm',
  '昵称': 'Nickname',
  '物流中心名称': 'Logistics Center Name',
  '状态': 'State',
  '禁用': 'Disabled',
  '启用': 'Enable',
  '头像': 'Profile Picture',
  '重置密码': 'Reset Password',
  '密码': 'Password',
  '性别': 'Gender',
  '用户名': 'User Name',
  '手机号': 'Phone Number',
  '用户账号': 'User ID',
  '反馈类型': 'Feedback Type',
  '反馈内容': 'Feedback Content',
  '反馈图片': 'Feedback Image',
  '回复内容': 'Reply Content',
  '处理': 'Process',
  '总数': 'Total Number',
  '处理总数': 'Total Processed',
  '未处理总数': 'Total Pending',
  '待处理': 'Pending',
  '已处理': 'Processed',
  '产品建议': 'Product Suggestions',
  '功能故障': 'Feature Malfunction',
  '其他问题': 'Others',
  '简述': 'Summary',
  '内容': 'Content',
  '序号': 'No.',
  '登录账号':'Login ID',
  '重置为默认密码':'Reset to Default Password',
  '设备列表':'Device List',
  '请输入':'Please Enter ',
  '问题标题':'Question Title',
  '修改':'Edit',
  '设备详情':'Device Details',
  '返回':'Return',
  '信息概览':'Information Summary',
  '采集':'Collection',
  '报警值':'Alarm Value',
  '历史轨迹':'Historical Track',
  '最后登录时间':'Last Login Time',
  '注册时间':'Registration Date',
  '用户总数':'Total Users',
  '禁用用户总数':'Total Number of Disable Users',
  '确定要禁用该用户吗':'Are you sure you want to disable this user ?',
  '请选择商家':'Please Select a Merchant',
  '请选择门店':'Please Select Store',
  '总门店数':'Total Number of Stores',
  '停用店铺数':'Number of Disabled Stores',
  '总订单数':'Total Number of Orders',
  '今日订单数':'Number of Orders Today',
  '本月订单数':' Number of Orders This Month',
  '反馈订单数':'Number of Feedback Orders',
  '总收益金额':'Total Revenue Amount',
  '今日收益金额':'Today’s Revenue Amount',
  '本月收益金额':'This Month’s Revenue Amount',
  '总用户数':'Total Users',
  '平台用户数':'Platform Users',
  '总商家数':'Total Merchants',
  '今日注册':'Registration Today',
  '本月注册':'Registration This month',
  '反馈设备数':'Number of Feedback Devices',
  '总仓库数':'Total Storage',
  '总办公室数':'Total Offices',
  '总会议室数':'Total Meeting Rooms',
  '总座位数':'Total Seats',
  '总继电器数':'Total Relay',
  '总设备数':'Total Devices',
  '设备在线数':'Device Online',
  '设备离线数':'Device Offline',
  '订单数':'Order No.',
  '用户曲线':'User Curve',
  '收益':'Revenue',
  '设备数':'Number of Devices',
  '问题占比':'Problem Proportion',
  '用户活跃':'User Activity',
  '用户注册':'User Registration',
  '门店增加':'Store Increase',
  '代理商排名':'Agent Ranking',
  '总收益':'Total Revenue',
  '场地数':'Number of Stores',
  '排名':'Ranking',
  '商家名称':'Merchant’s Name',
  '门店数':'Number of Stores',
  '门店名称':'Store Name',
  '总营收':'Total Revenue',
  '用户编码':'User Code',
  '注销原因':'Cause of logout',
  '注销时间':'logout time',
  '角色': 'Role',
  '区号': 'Area Code',
  '门店数量': 'Number of Stores',
  '最后登录IP': 'Last login IP',
  '备注': 'Remarks',
  '登录密码': 'Login Password',
  '确认密码': 'Confirm Password',
  '全部':'All',
  '会议室':'Meeting Room',
  '办公室':'Office',
  '仓库':'Storage',
  '同步':'Sync',
  '批量绑定门店':'Bulk Bind Store',
  '店铺名称':'Store Name',
  '商家手机号':'Merchant’s Mobile Number ',
  '绑定房间编号':'Bound Room Number',
  '设备版本号':'Device Version Number',
  '导出':'Export',
  '所属店铺':'Affiliated Store',
  '所属商家':'Affiliated Merchant',
  '订单':'Order',
  '日志':'Log',
  '今日销售额':'Sales Today',
  '总销售额':'Total Sales',
  '子设备数':'Number of Sub-Devices',
  '设备信息':'Device Information',
  '营业额':'Turnover',
  '设备房间类型':'Device Room Type',
  '版本号':'Version No.',
  '最近上线时间':'Last Online Time',
  '最近离线时间':'Last Offline Time',
  '下载模板':'Download Template',
  '批量绑定商家':'Bulk Bind Merchant',
  '设备状态':'Device Status',
  '在线时间':'Online Time',
  '离线时间':'Offline Time',
  '名称':'Name',
  '负责人手机号':'PIC Mobile Number',
  '共享座位':'Seats',
  '共享会议室':'Meeting Room',
  '共享办公室':'Office',
  '共享仓库':'Storage',
  '主图':'Main Diagram',
  '地址':'Address',
  '配置座位':'Configure Seat',
  '配置会议室':'Configure Meeting Room',
  '配置办公室':'Configure Office',
  '配置仓库':'Configuration Storage',
  '上架':'Available',
  '下架':'Unavailable',
  '座位配置':'Seat Configuration',
  '收费模板':'Fee Template',
  '按小时租借':'by Hours',
  '按月租借':'by Month',
  '座位分布图':'Seating Map',
  '小时费用':'Hourly Fees',
  '月费用':'Monthly Fees',
  // '按照天租借':'by Day',
  '按照年租借':'by Year',
  '天费用':'Daily Fees',
  '年费用':'Annual Fees',
  '座位编号':'Seat No.',
  '确认':'Confirm',
  '取消':'Cancel',
  '使用状态':'Usage Status',
  '使用开始时间':'Use Start Time',
  '使用结束时间':'Use End Time',
  '请选择座位编号':'Please Select Seat Number',
  '会议室配置':'Meeting Room Configuration',
  '会议室分布图':'Meeting Room Layout',
  '房间编号':'Room No.',
  '指纹数':'Fingerprint',
  '座位数':'Seat Number',
  '房间大小':'Room Size',
  '房间图片':'Room Photo',
  '时间类型':'Time Type',
  '订单类型':'Order Type',
  '订单状态':'Order Status',
  '支付状态':'Payment Status',
  '订单金额':'Order Amount',
  '用户信息':'User Information',
  '用户头像':'User Profile Pictures',
  '订单信息':'Order Information',
  '外部订单号':'External Order Number',
  '支付时间':'Payment Time',
  '使用人数':'Number of Users',
  '座位数量':'Number of Seats',
  '支付方式':'Payment Method',
  '支付金额':'Payment Amount',
  '收费规则':'Charging Rules',
  '模板名称':'Template Name',
  '收费金额':'Charge Amount',
  '门店信息':'Store Information',
  '联系方式':'Contact Information',
  '售后信息':'After-Sales Information',
  '售后反馈':'After-Sales Feedback',
  '处理图片':'Processing Images',
  '处理结果':'Processing Result',
  '小时计费金额':'Hourly Charges',
  '天计费金额':'Daily Charges',
  '月计费金额':'Monthly Charges',
  '年计费金额':'Annual Charges',
  '回复状态':'Reply Status',
  '评论图片':'Comment Image',
  '评论内容':'Comment Content',
  '评分':'Score',
  '回复用户昵称':'Reply to User’s Nickname',
  '回复用户手机号':'Reply to User’s Mobile Number',
  '回复时间':'Reply Time',
  '回复':'Reply',
  '终端':'Terminal',
  '升级类型':'Upgrade Type',
  '版本名称':'Version Name',
  '更新类型':'Update Type',
  '计划更新':'Scheduled Update',
  '计划更新时间':'Scheduled Update Time',
  '更新内容':'Update Content',
  '已更新数':'Updated Number',
  '用户端':'Users',
  '商家端':'Merchant',
  '整包更新':'Full Package Update',
  '立即更新':'Update Now',
  '等待升级':'Wait for Upgrade',
  '下发':'Send',
  '参数名称':'Parameter Name,',
  '参数分组':'Parameter Group',
  '系统内置':'System Built-In',
  '参数键名':'Parameter Key',
  '参数类型':'Parameter Type',
  '参数键值':'Parameter Key Value',
  '消息类型':'Message Type',
  '消息终端':'Message Terminal',
  '消息标题':'Message Title ',
  '消息简述':'Message Brief',
  '消息内容':'Message Content',
  '业务类型':'Business Type',
  '请求方法':'Request Method',
  '请求地址':'Request address',
  '请求参数':'request parameters',
  '操作类型':'Operation type',
  '操作人员':'Operator',
  '操作地点':'Operating location',
  '请选择代理商':'Please Select an Agent',
  '门店排名':'Store Ranking',
  '保密':'Confidential',
  '正常':'Normal',
  '代理商':'Agent',
  '代理商手机号':'Agent’s Mobile Number',
  '在线状态':'Online Status',
  '待支付':'Pending Payment',
  '日':'Day',
  '已支付':'Paid',
  '小时':'Hour',
  '完成':'Complete',
  '房间类型':'Room Type',
  '操作人账号':'Operator Account',
  '操作内容':'Operation Details',
  '导入':'Import',
  '在线':'Online',
  '离线':'Offline',
  '大门':'Main Door',
  '操作时间':'Operation Time',
  '停用':'Deactivate',
  '是':'Yes',
  '否':'No',
  '是否配置座位':'Seats Configured',
  '是否配置会议室':'Meeting Room Configured',
  '是否配置办公室':'Office Configured',
  '是否配置仓库':'Storage Configured',
  '店铺信息':'Store Information',
  '房间配置':'Room Details',
  '最短租借分钟':'Minimum Rental Duration',
  '好评星级':'Good Rate',
  '营业时间':'Business Hours',
  '详情图':'Detail Image',
  '按照小时租借':'Hourly Rental',
  '按照天租借':'Daily Rental',
  '按照月租借':'Monthly Rental',
  '时费用':'Hourly Fee',
  '人脸门锁':'Digital Face Lock',
  '密码门锁':'Digital Door Lock',
  '继电器':'Relay',
  '评论':'Comment',
  '用户手机号':'User‘s Mobile Number',
  '已回复':'Replied',
  '刷新':'Refresh',
  '系统消息':'System Notification',
  '个人中心':'My Profile',
  '工作台':'Dashboard',
  '最短时间限制':'Minimum time limit',
  '总收入':'Total Revenue',
  '完成订单金额':'Total Order Completed',
  '取消订单金额':'Total Cancel Order',
  '平均每日订单数':'Average Order per day',
  '三方编号':'Tripartite numbering',
  '总支付金额':'Total payment',
  '总支付订单数':'Total payment order number',
  '订单号':'order number',
  '已完成':'completed',
  '银行卡':'bank card',
  '女':'girl',
  '商家':'merchant',
  '设备':'equipment',
  '隐藏':'conceal',
  '升级中':'updating',
  '暂停':'suspend',
  '升级暂停':'Upgrade pause',
  '数据删除后无法恢复，请确认!':'Data can not be recovered after deletion, please confirm!',
  '下发升级':'Deliver the upgrade',
  '最短时间限制(分钟)':'Minimum time limit (minutes)',
  '营业开始时间(星期)':'Opening hours (Week)',
  '营业结束时间(星期)':'Closing hours (Weekdays)',
  '营业时间范围':'Operating hours',
  '是否有座位':'Are there seats available',
  '是否有会议室':'Is there a meeting room',
  '是否有办公室':'Is there an office',
  '是否有仓库':'Is there a warehouse',
  '周一':'Monday',
  '周二':'Tuesday',
  '周三':'Wednesday',
  '周四':'Thursday',
  '周五':'Friday',
  '周六':'Saturday',
  '周日':'weekday',
  '预约说明':'Reservation instructions',
  '门店简述':'Store description',
  '详情多图':'Detail map',
  '所属商户':'Affiliated merchant',
  '设备主类型':'Device master type',
  '未处理':'untreated',
  '后台用户':'Background user',
  '管理员':'Administrator',
  '运行门店数':'Number of operating stores',
  '停用门店数':'Number of closed stores',
  '商家排名':'Merchant ranking',
  '近一个月':'Nearly a month',
  '近六个月':'Nearly six months',
  '人脸照片':'Face photo',
  '身份证号':'ID number',
  '故障报告':'failure report',
  '意见建议':'opinions and suggestions',
  '安卓':'Android',
  '未回复':'no reply',
  '人气':'popularity',
  '生成订单':'create order',
  '使用时间类型':'Use time type',
  '月':'month',
  '年':'year',
  '请选择日期以及时间':'Please select a date and time',
  '请输入备注':'Please enter remarks',
  '可用':'usable',
  '不可用':'not applicable',
  '使用中':'in use',
  '收费配置':'Charge allocation',
  '座位列表配置':'Seat list configuration',
  '座位分布图配置':'Seat layout configuration',
  '会议室分布图配置':'Meeting room layout configuration',
  '会议室房间列表配置':'Meeting room list configuration',
  '办公室分布图配置':'Office distribution map configuration',
  '办公室列表配置':'Office list configuration',
  '仓库分布配置':'Warehouse distribution configuration',
  '仓库列表配置':'Warehouse list configuration',
}
